import component from './all.vue'

export default component
